<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h410_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="所属省区"
                  prop="provinceId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item
                  label="报告类型"
                  prop="type"
                >
                  <el-radio-group
                    v-model="dialogAddEditViewForm.type"
                    :disabled="eventType === 'view'"
                  >
                    <el-radio :label="1">
                      周报
                    </el-radio>
                    <el-radio :label="2">
                      月报
                    </el-radio>
                    <el-radio :label="3">
                      季报
                    </el-radio>
                    <el-radio :label="4">
                      年报
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="周期名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    maxlength="64"
                    placeholder="请输入市场报告周期名称"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="开始时间"
                  prop="startDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.startDate"
                    type="date"
                    placeholder="请选择周期开始时间"
                    style="width:100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType === 'view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="结束时间"
                  prop="endDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditViewForm.endDate"
                    type="date"
                    placeholder="请选择周期结束时间"
                    style="width:100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :disabled="eventType === 'view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    maxlength="128"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { listAreaApi } from '@/api/v2/area'
import { saveMarketReportPeriodApi, viewMarketReportPeriodApi } from '@/api/v2/marketReportPeriod'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        type: [{ required: true, message: '请选择报告类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入报告周期名称', trigger: 'blur' }, { max: 64, message: '最多输入64个字符', trigger: 'blur' }],
        startDate: [{ required: true, message: '请输入报告周期开始日期', trigger: ['change', 'blur'] }],
        endDate: [{ required: true, message: '请输入报告周期结束日期', trigger: ['change', 'blur'] }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }],
      },
      provinceOptions: [],
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this

        _this.dialogAddEditViewForm = {
          provinceId: null,
          provinceName: '',
          type: 1,
          name: '',
          startDate: '',
          endDate: '',
          remark: '',
        }

        if (_this.eventType !== 'view') {
          _this.loadProvinceData()
        }

        if (_this.eventType !== 'add') {
          _this.loadMarketReportPeriodData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadMarketReportPeriodData () {
      let _this = this
      viewMarketReportPeriodApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          if (!data[key]) continue
          _this.dialogAddEditViewForm[key] = data[key]
        }
        _this.dialogAddEditViewForm.id = data.id
      })
    },
    // 获取省区下拉数据
    loadProvinceData () {
      let _this = this;
      _this.provinceOptions = [];
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.provinceOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 选择省区回调
    handleProvinceChange (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.provinceOptions.find(item => {
        return item.value === val
      })
      _this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
    },
    // 新增|修改保存
    handleSave () {
      let _this = this
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '市场报告周期设置', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true })
            .then(async () => {
              saveMarketReportPeriodApi(_this.dialogAddEditViewForm).then(() => {
                _this.$message({ message: '保存成功', type: 'success' })
                _this.$emit('reloadData')
                _this.modalClose()
              }).catch(() => { })
            }).catch(() => { })
        }
      })
    },
    modalClose () {
      let _this = this
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
